<script setup lang="ts">
import { cn } from '@/utils';
import { CurrencyDisplay, useCurrencyInput } from 'vue-currency-input';

import { creditSimulatorFieldVariants } from '.';

// `modelValue` is the contract useCurrencyInput reads and emits by itself.
const props = defineProps<{
	id: string;
	label: string;
	modelValue: number | null;
}>();

defineEmits<{
	'update:modelValue': [value: number | null];
	commit: [];
}>();

// The library keeps the caret in place while the value is regrouped.
const { inputRef, numberValue, setValue } = useCurrencyInput({
	locale: 'pt-BR',
	currency: 'BRL',
	currencyDisplay: CurrencyDisplay.symbol,
	precision: 0,
	hideCurrencySymbolOnFocus: false,
	hideGroupingSeparatorOnFocus: false,
	hideNegligibleDecimalDigitsOnFocus: false,
	useGrouping: true
});

// The slider and the limits applied on blur change the value from outside.
watch(
	() => props.modelValue,
	value => {
		if (value !== numberValue.value) setValue(value);
	}
);
</script>

<template>
	<input
		:id="id"
		ref="inputRef"
		type="text"
		inputmode="numeric"
		:aria-label="label"
		:class="cn(creditSimulatorFieldVariants({ variant: 'value' }), 'w-[170px]')"
		@blur="$emit('commit')"
	/>
</template>
